/** 用户类型 */
export enum EnumUserType {
  Teacher = 1,
  Student = 2,
}

/** 角色类型 */
export enum EnumRoleType {
  /** 系统角色 */
  SYSTEM = 1,
  /** 自定义角色 */
  CUSTOM = 2,
}

/** 主题数据权限类型 */
export enum EnumPermissionType {
  /** 适配个人权限 */
  USER = 1,
  /** 主题权限配置 */
  TOPIC = 2,
}

/** boolean类型 */
export enum EnumTrueFalse {
  False = 0,
  True = 1,
}

/** 数据集表分类 */
export enum EnumClassify {
  entity = 1,
  common = 2,
}

/** 实体检测类型 */
export enum EnumEntityDetection {
  year = '学年检测',
  semester = '学期检测',
  college = '学院名称检测',
  faculty = '系名称检测',
  major = '专业名称检测',
  clazz = '班级名称检测',
  student = '学生姓名检测',
  teacher = '教师姓名检测',
}

/** 术语库-术语类型 */
export enum EnumParlanceType {
  common = 1,
  topic = 2,
}

/** 偏好类型 */
export enum EnumPreferenceType {
  common = 1,
  topic = 2,
}

/** 代码示例类型 */
export enum EnumCodeExampleType {
  /** 通用示例 */
  common = 1,
  /** 关联主题 */
  topic = 2,
}

/** 思路配置阶段类型 */
export enum EnumThinkStageType {
  parse = 1,
  coding = 2,
  exec = 3,
  makeChart = 4,
  dataRead = 5,
  result = 6,
}

/** 思路配置类型 */
export enum EnumThinkConfigType {
  common = 1,
  topic = 2,
}

/** 分享范围 */
export enum EnumShareType {
  /** 部分公开 */
  part = 1,
  /** 校内公开 */
  college = 2,
  /** 校外公开 */
  internet = 3,
}

/** 报告收藏状态 */
export enum EnumReportCollectStatus {
  /** 已收藏 */
  IS = 1,
  /** 未收藏 */
  NOT = 2,
}

/** 主题公开分享有效期 */
export enum EnumTopicValidType {
  /** 永久有效 */
  permanent = 1,
  /** 指定时间有效 */
  specified = 2,
}
